import React, { useState } from 'react';
import { login } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import { loginSchema } from '../../utils/validation';
import FieldError from '../../utils/FieldError';

const SignInPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [mensaje, setMensaje] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = loginSchema.safeParse(form);
    if (!result.success) {
      const fieldErrors = {};
      result.error.issues.forEach((i) => { fieldErrors[i.path[0]] = i.message; });
      setErrors(fieldErrors);
      return;
    }
    try {
      const data = await login(result.data);
      localStorage.setItem('jwt', data.token);
      window.dispatchEvent(new Event('authChange'));
      setMensaje('');
      navigate('/');
    } catch (err) {
      setMensaje(err.mensaje || 'Error al iniciar sesión');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="w-full max-w-sm">
        <form onSubmit={handleSubmit} className="bg-white shadow-sm border border-gray-200 rounded-lg px-8 py-10 space-y-6">
          <div className="text-center">
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">Inicio de Sesión</h1>
            <p className="text-sm text-gray-500">Ingrese con su email y contraseña</p>
          </div>

          <div className="space-y-4">
            <div>
              <input name="email" type="email" placeholder="Correo" value={form.email} onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
              <FieldError message={errors.email} />
            </div>
            <div>
              <input name="password" type="password" placeholder="Contraseña" value={form.password} onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
              <FieldError message={errors.password} />
            </div>
          </div>

          <button type="submit"
            className="w-full py-2.5 px-4 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 transition-colors">
            Ingresar
          </button>

          {mensaje && <p className="text-sm text-center font-medium text-red-500">{mensaje}</p>}
        </form>
      </div>
    </div>
  );
};

export default SignInPage;
